import axios from 'axios';
import { URI_TARGET } from '../helpers/constans';

export const fetchTarget = (id: string) => {
  return axios.get(`${URI_TARGET}/${id}`);
};
